function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "4vfjpcwswa",
  width: 256,
  height: 256,
  x: 0,
  y: 0,
  rx: 42.667
}));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  fill: "#FFB511"
}, /*#__PURE__*/React.createElement("rect", {
  width: 256,
  height: 256,
  rx: 42.667
})), /*#__PURE__*/React.createElement("mask", {
  id: "13i3tk9b3b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#4vfjpcwswa"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#2175D9",
  xlinkHref: "#4vfjpcwswa"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#13i3tk9b3b)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#6BA5B4",
  d: "M122 94.415c13.244 0 24 10.706 24 23.887V178H98v-59.733c0-13.181 10.756-23.852 24-23.852zM122 35c13.255 0 24 10.82 24 24.169 0 13.348-10.745 24.169-24 24.169s-24-10.82-24-24.169C98 45.821 108.745 35 122 35z",
  transform: "translate(0.000000, 38.000000) translate(71.000000, 0.000000)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFB511",
  d: "M67 94.415c13.244 0 24 10.706 24 23.887V178H43v-59.733c0-13.181 10.756-23.852 24-23.852zM67 35c13.255 0 24 10.82 24 24.169 0 13.348-10.745 24.169-24 24.169s-24-10.82-24-24.169C43 45.821 53.745 35 67 35z",
  transform: "translate(0.000000, 38.000000) translate(71.000000, 0.000000)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F5F0",
  d: "M30 73.83c16.555 0 30 13.341 30 29.769V178H0v-74.445C0 87.128 13.445 73.83 30 73.83zM30 0c16.569 0 30 13.358 30 29.835C60 46.313 46.569 59.67 30 59.67c-16.569 0-30-13.357-30-29.835C0 13.358 13.431 0 30 0z",
  transform: "translate(0.000000, 38.000000) translate(71.000000, 0.000000)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#0F1941",
  d: "M106 138.18c0-5.395-4.292-9.763-9.639-9.917 5.347-.155 9.639-4.548 9.639-9.919 0-5.319-4.19-9.661-9.459-9.918-.154 0-.334-.026-.488-.026H92.71c.72-.18 1.388-.462 2.031-.796.026 0 .026-.026.051-.026 3.188-1.67 5.372-5.01 5.372-8.839 0-5.524-4.06-10.02-9.998-9.995H59.863l2.75-6.912C66.803 69.96 60.917 56.779 50.943 52L36.19 88.744c-1.722 4.214-6.4 13.207-15.602 13.207H2.21c-1.233 0-2.21 1.002-2.21 2.21v55.63C0 161.023 1.002 162 2.21 162h82.611c13.725 0 13.417-11.331 11.437-13.772.052-.078.026-.052.078-.155 5.372-.102 9.664-4.496 9.664-9.892z",
  transform: "translate(0.000000, 38.000000)"
})))));
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f1485fa2e3c5b51324bc34b5e9518f9e.svg";
export { ForwardRef as ReactComponent };